import { HttpRequestBuilder } from "./http/HttpRequestBuilder";

export const getSessionToken = function() {
    let params = new URL(document.location.href).searchParams;
    return params.get("token") ? params.get("token") : params.get("sessionToken"); 
};

export const isFilterUrl = function() {
    return new URL(document.location.href).pathname.includes("/monday/imap/v1/config/filter");
};

export const isDocs = function() {
    let params = new URL(document.location.href).searchParams;
    return (params.get("docs") == "true"); 
};

export const isSettings = function() {
    let params = new URL(document.location.href).searchParams;
    return (params.get("settings") == "true"); 
};

const URL_BASE = document.location.origin;
export const URL_CREATE_ACCOUNT = URL_BASE + "/monday/imap/v1/credential/imap/create";
export const URL_GET_ACCOUNT = URL_BASE + "/monday/imap/v1/credential/imap/get";
export const URL_CREATE_FILTER = URL_BASE + "/monday/imap/v1/credential/filter/create";
export const URL_GET_FILTER = URL_BASE + "/monday/imap/v1/credential/filter/get";
export const URL_QUERY_SESSION_TOKEN = "?token=" + getSessionToken();

export const createAccount = async function(account) {
    try {
        const response = await new HttpRequestBuilder()
            .method('put')
            .url(URL_CREATE_ACCOUNT + URL_QUERY_SESSION_TOKEN)
            .headers({ 
            "Content-Type": "application/json",
            "Accept": "application/json"
            })
            .data(account)
            .send();

        return response.data.error ? { error: response.data.error } : { backToUrl : response.data.backToUrl };
    } catch(err) {
        console.error(err);
        return "An unknown error has occured while creating account. Please try again.";
    }
}

export const getAccounts = async function() {
    try {
        const response = await new HttpRequestBuilder()
            .method('post')
            .url(URL_GET_ACCOUNT + URL_QUERY_SESSION_TOKEN)
            .headers({
            "Content-Type": "application/json",
            "Accept": "application/json"
            })
            .send();

        return response.data;
    } catch(err) {
        console.error(err);
        return {msg: "An unknown error has occured while loading accounts. Please try again.", code: err?.response?.status};
    }
}

export const getFullAccount = async function(id) {
    try {
        const response = await new HttpRequestBuilder()
            .method('post')
            .url(URL_GET_ACCOUNT + URL_QUERY_SESSION_TOKEN)
            .headers({
            "Content-Type": "application/json",
            "Accept": "application/json"
            })
            .data({id: id})
            .send();

        return response.data;
    } catch(err) {
        console.error(err);
        return {msg: "An unknown error has occured while loading account details. Please try again.", code: err?.response?.status};
    }
}

export const createFilter = async function(filter) {
    try {
        const response = await new HttpRequestBuilder()
            .method('put')
            .url(URL_CREATE_FILTER + URL_QUERY_SESSION_TOKEN)
            .headers({ 
            "Content-Type": "application/json",
            "Accept": "application/json"
            })
            .data(filter)
            .send();

        return response.data.error ? { error: response.data.error } : { backToUrl : response.data.backToUrl };
    } catch(err) {
        console.error(err);
        return "An unknown error has occured while creating account. Please try again.";
    }
}

export const getFilters = async function() {
    try {
        const response = await new HttpRequestBuilder()
            .method('post')
            .url(URL_GET_FILTER + URL_QUERY_SESSION_TOKEN)
            .headers({
            "Content-Type": "application/json",
            "Accept": "application/json"
            })
            .send();

        return response.data;
    } catch(err) {
        console.error(err);
        return {msg: "An unknown error has occured while loading filters. Please try again.", code: err?.response?.status};
    }
}

export const getFullFilter = async function(id) {
    try {
        const response = await new HttpRequestBuilder()
            .method('post')
            .url(URL_GET_FILTER + URL_QUERY_SESSION_TOKEN)
            .headers({
            "Content-Type": "application/json",
            "Accept": "application/json"
            })
            .data({id: id})
            .send();

        return response.data;
    } catch(err) {
        console.error(err);
        return {msg: "An unknown error has occured while loading filter details. Please try again.", code: err?.response?.status};
    }
}
